module.exports = __webpack_public_path__ + "img/task-5-g.2084c0b0.png";